import React, { useState, useEffect, useRef } from 'react';

import EditModalShell from '../forms/EditModalShell/EditModalShell';
import FormField from '../forms/FormField/FormField';

import './FaqModal.css';

const FaqModal = ({ onClose, onSubmit, faq, mode }) => {
  const initialFormState = {
    question: '',
    answer: '',
    order: 0,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(false);
  const { question, answer, order } = formData;

  const firstInputRef = useRef();

  useEffect(() => {
    setFormData({
      question: faq?.question || '',
      answer: faq?.answer || '',
      order: faq?.order ?? 0,
    });

    firstInputRef.current?.focus();
  }, [mode, faq]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'order' ? Number(value) : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await onSubmit(formData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <EditModalShell
      formId='faq-modal-form'
      onClose={onClose}
      onSubmit={handleSubmit}
      mode={mode}
      isLoading={loading}
      itemLabel='FAQ'
    >
      <FormField
        type='number'
        name='order'
        label='Order'
        value={order}
        onChange={handleInputChange}
        required
      />
      <FormField
        type='textarea'
        name='question'
        label='Question'
        value={question}
        onChange={handleInputChange}
        required
        ref={firstInputRef}
        className='faq-modal-question'
      />
      <FormField
        type='textarea'
        name='answer'
        label='Answer'
        value={answer}
        onChange={handleInputChange}
        className='faq-modal-answer'
      />
    </EditModalShell>
  );
};

export default FaqModal;
